import axios from "axios";
import { getToken, logout } from "../components/Auth/handleJWT";

export default function confugureInterceptor() {
  axios.interceptors.request.use(
    function (config) {
      const token = getToken();

      if (token && config && config.headers) {
        config.headers.Authorization = `bearer ${token}`;
      }

      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
}
